<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconExport" clip-path="url(#clip0_3586_39804)">
      <path
        id="Vector"
        d="M5.50341 1.789L5.49991 9.508C5.49991 9.6406 5.55258 9.76778 5.64635 9.86155C5.74012 9.95532 5.8673 10.008 5.99991 10.008C6.13251 10.008 6.25969 9.95532 6.35346 9.86155C6.44723 9.76778 6.49991 9.6406 6.49991 9.508L6.50341 1.7975L7.95941 3.254C8.05317 3.34773 8.18032 3.40039 8.3129 3.40039C8.44549 3.40039 8.57264 3.34773 8.66641 3.254C8.76014 3.16023 8.8128 3.03308 8.8128 2.9005C8.8128 2.76791 8.76014 2.64076 8.66641 2.547L7.06091 0.939497C6.9216 0.800107 6.7562 0.689532 6.57415 0.61409C6.3921 0.538647 6.19697 0.499817 5.99991 0.499817C5.80284 0.499817 5.60771 0.538647 5.42566 0.61409C5.24361 0.689532 5.07821 0.800107 4.93891 0.939497L3.3334 2.5455C3.23967 2.63926 3.18701 2.76641 3.18701 2.899C3.18701 3.03158 3.23967 3.15873 3.3334 3.2525C3.42717 3.34623 3.55432 3.39889 3.6869 3.39889C3.81949 3.39889 3.94664 3.34623 4.04041 3.2525L5.50341 1.789Z"
        fill="#434343"
      />
      <path
        id="Vector_2"
        d="M11 9V11C11 11.1326 10.9473 11.2598 10.8536 11.3536C10.7598 11.4473 10.6326 11.5 10.5 11.5H1.5C1.36739 11.5 1.24021 11.4473 1.14645 11.3536C1.05268 11.2598 1 11.1326 1 11V9C1 8.86739 0.947322 8.74021 0.853553 8.64645C0.759785 8.55268 0.632608 8.5 0.5 8.5C0.367392 8.5 0.240215 8.55268 0.146447 8.64645C0.0526784 8.74021 0 8.86739 0 9L0 11C0 11.3978 0.158035 11.7794 0.43934 12.0607C0.720644 12.342 1.10218 12.5 1.5 12.5H10.5C10.8978 12.5 11.2794 12.342 11.5607 12.0607C11.842 11.7794 12 11.3978 12 11V9C12 8.86739 11.9473 8.74021 11.8536 8.64645C11.7598 8.55268 11.6326 8.5 11.5 8.5C11.3674 8.5 11.2402 8.55268 11.1464 8.64645C11.0527 8.74021 11 8.86739 11 9Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3586_39804">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
